import React, { useState } from 'react';
import { Button, InputAdornment, Input, Typography } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { MdOutlineAlternateEmail, MdLock } from 'react-icons/md';
import Modal from 'styled-react-modal';
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import { notifyRegistartionError, notifyLoginError } from './errorsHandler';
import { avatars } from '../../services/avatars';
import { useStyles } from './styles';
import './styles.sass';

// Firebase
import { authentication } from '../../services';
import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    updateProfile
} from 'firebase/auth';

const Authentication = ({ open, setOpen }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [avatar, setAvatar] = useState(1);
    const classes = useStyles();

    const resetForm = () => {
        setEmail('');
        setPassword('');
        setShowPassword(false);
        setAvatar(1);
    }

    const handleClose = () => {
        setOpen(false);
        resetForm();
    }

    const onRegister = (event) => {
        event.preventDefault();
        createUserWithEmailAndPassword(authentication, email, password)
            .then(() => {
                updateProfile(
                    authentication.currentUser,
                    { photoURL: avatars[avatar - 1].url }
                );
            })
            .then(() => setOpen(false))
            .catch((error) => notifyRegistartionError(error.message));
    }

    const onSignIn = (event) => {
        event.preventDefault();
        signInWithEmailAndPassword(authentication, email, password)
            .then(() => setOpen(false))
            .catch((error) => notifyLoginError(error.message));
    }

    return (
        <StyledModal
            isOpen={open}
            onBackgroundClick={handleClose}
            onEscapeKeydown={handleClose}
        >
            <div style={{ width: '100%', height: '100%' }}>
                <TabsUnstyled defaultValue={0} onChange={resetForm}>
                    <TabsList>
                        <Tab style={{ borderTopRightRadius: 25 }}>הרשמה</Tab>
                        <Tab style={{ borderTopLeftRadius: 25 }}    >התחברות</Tab>
                    </TabsList>
                    <TabPanel value={0}>
                        <form onSubmit={onRegister}>
                            <Typography variant='subtitle1' className={classes.label}>אימייל</Typography>
                            <div className="input-wrapper">
                                <Input
                                    required
                                    autoFocus
                                    disableUnderline
                                    placeholder="מה המייל שלך?"
                                    value={email}
                                    type="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={classes.input}
                                    startAdornment={<MdOutlineAlternateEmail className={classes.startAdornment} />}
                                />
                            </div>
                            <Typography variant='subtitle1' className={classes.label}>סיסמה</Typography>
                            <div className="input-wrapper">
                                <Input
                                    required
                                    disableUnderline
                                    placeholder="חייבת להכיל 6 תווים לפחות"
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classes.input}
                                    startAdornment={<MdLock className={classes.startAdornment} />}
                                    endAdornment=
                                    {
                                        <InputAdornment position="end"
                                            onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ?
                                                <VisibilityOffIcon className={classes.icon} />
                                                :
                                                <VisibilityIcon className={classes.icon} />
                                            }
                                        </InputAdornment>
                                    }
                                />
                            </div>
                            <Typography variant='subtitle1' className={classes.label}>בחירת אווטאר</Typography>
                            <div className="avatars">
                                {avatars.map((item, index) => {
                                    return (
                                        <div
                                            key={item.key}
                                            className={avatar === item.key ? "avatar selected" : "avatar unselected"}
                                            onClick={() => setAvatar(item.key)}
                                        >
                                            <img src={item.url} alt={index} />
                                        </div>
                                    )
                                })}
                            </div>
                            <Button className={classes.button} type="submit" variant="contained">הרשמה</Button>
                        </form>
                    </TabPanel>
                    <TabPanel value={1}>
                        <form onSubmit={onSignIn}>
                            <Typography variant='subtitle1' className={classes.label}>אימייל</Typography>
                            <div className="input-wrapper">
                                <Input
                                    required
                                    autoFocus
                                    disableUnderline
                                    placeholder="מה המייל שלך?"
                                    value={email}
                                    type="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    className={classes.input}
                                    startAdornment={<MdOutlineAlternateEmail className={classes.startAdornment} />}
                                />
                            </div>
                            <Typography variant='subtitle1' className={classes.label}>סיסמה</Typography>
                            <div className="input-wrapper">
                                <Input
                                    required
                                    disableUnderline
                                    placeholder="מהי הסיסמה שלך?"
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className={classes.input}
                                    startAdornment={<MdLock className={classes.startAdornment} />}
                                    endAdornment=
                                    {
                                        <InputAdornment position="end"
                                            onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ?
                                                <VisibilityOffIcon className={classes.icon} />
                                                :
                                                <VisibilityIcon className={classes.icon} />
                                            }
                                        </InputAdornment>
                                    }
                                />
                            </div>
                            <Button className={classes.button} type="submit" variant="contained">התחברות</Button>
                        </form>
                    </TabPanel>
                </TabsUnstyled>
            </div>
        </StyledModal>
    )
}

const Tab = styled(TabUnstyled)`
    display: flex;
    justify-content: center;
    width: 100%;
    font-family: 'Rubik', sans-serif;
    letter-spacing: 1.5px;
    font-size: 20px;
    padding: 12px 16px;
    border: none;
    color: #FFFFFF80;
    background-color: #121f25;
    cursor: pointer;
  
    &:hover {
        background-color: #121f2580;
    }
  
    &.${tabUnstyledClasses.selected} {
      background-color: #000f14;
      color: white;
    }
`;

const TabPanel = styled(TabPanelUnstyled)`
    width: 100%;
    padding: 20px 40px;
`;

const TabsList = styled(TabsListUnstyled)`
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;
`;

const StyledModal = Modal.styled`
    width: 450px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 25px;
    background-color: #000f14;
    cursor: default;

    @media (max-width: 400px) {
        width: 100%;
    }
`;

export default Authentication;